export default "__VITE_ASSET__DRLBlCVC__"